let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4kqRf")).then(() => parcelRequire('heBKY'));